export function getCurrentTimestamp() {
  return new Date().getTime();
}

export function getTimestampByDate(d) {
  return new Date(d).getTime();
}
